import styleConfigHelper from './styleConfigHelper';
import util from './util';

class mapConfigHelper {
    constructor(config) {
        if (!mapConfigHelper.instance || config) {
            mapConfigHelper.instance = this;
            mapConfigHelper.instance._defaultCenter = { lat: -34.397, lng: 150.644 };
            mapConfigHelper.instance._defaultZoom = 6;
            mapConfigHelper.instance._config = config;
        }

        return mapConfigHelper.instance;
    }

    getMapCenter = () => {
        let tmpCenter;
        if (this._config?.CenterLat && this._config?.CenterLng) {
            tmpCenter = {
                lat: this._config?.CenterLat,
                lng: this._config?.CenterLng
            };
        } else tmpCenter = this.getDefaultCenter();

        return tmpCenter;
    };

    getMapType = () => {
        let defaultType = 'roadmap';
        let typeArray = ['roadmap', 'satellite', 'hybrid', 'terrain'];

        if (this._config?.MapType) {
            let tmpType = this._config.MapType;
            tmpType = tmpType.toLowerCase();
            if (typeArray.includes(tmpType)) return tmpType;
        }

        return defaultType;
    };

    getZoom = () => {
        return this._config?.Zoom ? this._config.Zoom : this.getDefaultZoom();
    };

    getDefaultCenter = () => {
        return this._defaultCenter;
    };

    getDefaultZoom = () => {
        return this._defaultZoom;
    };

    getClusterGroupArray = (list, group) => {
        const symbolConfig = new styleConfigHelper();

        let objList = [];

        list?.forEach(function (item) {
            let rootIndex = objList.findIndex((e) => e.clusterBy === item.item[group]);
            // Check the group exist is the list. If not exist, add to List.
            if (rootIndex == -1) {
                let color = symbolConfig.getColourData(item.item[group]);

                let tmp = {
                    clusterBy: item.item[group],
                    Markers: [item],
                    colorData: color,
                    order: color.DrawSort
                };
                objList.push(tmp);
            } else {
                objList[rootIndex].Markers.push(item);
            }
        });

        return objList;
    };

    getLegendArray = (data) => {
        const symbolConfig = new styleConfigHelper();

        let objList = [];
        data?.forEach(function (item) {
            if (!item) return;

            let rootIndex = objList.findIndex((e) => e.Group === item.Group);
            let tmpDiscriminator = !item.city ? 'Unknown' : item.city;

            //check the group exist is the list. If not exist, add to List.
            if (rootIndex == -1) {
                let color = symbolConfig.getColourData(tmpDiscriminator);
                let tmp = {
                    Group: item.Group,
                    Projects: [{ discr: tmpDiscriminator, count: 1, colorData: color, order: color.LegendSort }]
                };
                objList.push(tmp);
            } else {
                let projectIndex = objList[rootIndex].Projects.findIndex((e) => e.discr === tmpDiscriminator);
                // Check the Discriminator exists in the Group. If not existing, add to Group or raise the count
                if (projectIndex == -1) {
                    let color = symbolConfig.getColourData(tmpDiscriminator);
                    objList[rootIndex].Projects.push({
                        discr: tmpDiscriminator,
                        count: 1,
                        colorData: color,
                        order: color.LegendSort
                    });
                } else {
                    objList[rootIndex].Projects[projectIndex].count++;
                }
            }
        });

        const utilFunc = new util();
        objList.forEach(function (item) {
            item.Projects.sort(utilFunc.getSortOrder('count'));
        });

        return objList;
    };
}

export default mapConfigHelper;
